import React, { useEffect, useState } from "react";
import { axios } from "../../../../../Global";
import { setAppError, setBreadCrumb } from "../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import { useNavigate } from "react-router-dom";
import CostPlusCreate from "./CostPlusCreate/CostPlusCreate";
import CPCostSheetEdit from "./CostPlusEdit/CPCostSheetEdit";
import { useLocation } from "react-router-dom";

export default function CostSheetEdit({
  quotationDetails,
  quotationId,
  updateCostSheetForm,
  costSheetId,
  QUOTATION_DETAILS,
}) {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { breadCrumbs } = useSelector((state) => state.user);
  const [allowEdit, setAllowEdit] = useState(false);
  const location = useLocation();
  const routerState = location.state;

  console.log(routerState, "routerState");

  const [costSheetDataLoading, setCostSheetDataLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [costSheetDefault, setCostSheetDefault] = useState({});
  const [selectDatas, setSelectDatas] = useState();
  const [apiData, setApiData] = useState();
  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-orange-400",
      bgSecondary: "bg-orange-200",
    },
    ...(quotationDetails?.type?.name !== "Cost Plus"
      ? [
          {
            rate_category_id: 2,
            title: "GOVERNMENT FEES (PER MONTH)",
            bgPrimary: "bg-cyan-700",
            bgSecondary: "bg-cyan-200",
          },
          {
            rate_category_id: 3,
            title: "SOUNDLINE FEES (ACTUALS & PER MONTH)",
            bgPrimary: "bg-green-800",
            bgSecondary: "bg-green-200",
          },
        ]
      : []),
  ];

  const [allRows, setAllRows] = useState([
    {
      id: 1,
      job_position_id: "",
      visa_profession_id: "",
      profession_level_id: "",
      gender: "",
      nationality_id: "",
      quantity: "",
      sections: [
        {
          rate_category_id: 1,
          columns: [],
        },
        {
          rate_category_id: 2,
          columns: [],
        },
        {
          rate_category_id: 3,
          columns: [],
        },
      ],
    },
  ]);

  const style = {
    colWidth: "w-56",
    colHeight: "h-[3rem]",
    itemHeight: "h-[4rem]",
  };

  useEffect(() => {
    // Check if the "EDIT COST SHEET" breadcrumb is already in the array
    const isEditCostSheetInBreadcrumbs = breadCrumbs.some(
      (crumb) => crumb.label === "EDIT COST SHEET"
    );

    if (!isEditCostSheetInBreadcrumbs) {
      dispatch(
        setBreadCrumb([...breadCrumbs, { label: "EDIT COST SHEET", link: `` }])
      );
    }
  }, [location.pathname, QUOTATION_DETAILS]);
  console.log(quotationDetails, "quotation detials");

  useEffect(() => {
    axios
      .get(
        `/dashboard/quotation-cost-sheet-module-show-cost-sheet/${costSheetId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        const response = res?.data?.data;
        console.log("quotation check response.......",response);
        setApiData(response);
        const BASIC =
          response?.quotation_cost_sheet_profession_basic_information;
        const data = response;
        const groupedResult = {};

        data?.quotation_cost_sheet_headings?.forEach((heading) => {
          const rateCategoryId = heading?.rate_category_id;
          let rateCategoryItemName = heading?.rate_category_item_name;

          if (rateCategoryItemName === null) {
            const rateCategoryItem = data?.rate_category_item?.find(
              (item) => item?.id === heading?.rate_category_item_id
            );

            if (rateCategoryItem) {
              rateCategoryItemName = rateCategoryItem?.name;
            }
          }

          const resultItem = {
            id: heading?.id,
            rate_category_id: heading?.rate_category_id,
            rate_category_item_id: heading?.rate_category_item_id,
            rate_category_item_name: rateCategoryItemName,
            type: heading?.type,
            cost: "", // Initialize cost (fetch it separately)
            title: rateCategoryItemName,
          };

          const costDetail = data?.quotation_cost_sheet_cost_details?.find(
            (cost) => cost?.quotation_cost_sheet_heading_id === heading?.id
          );

          if (costDetail) {
            resultItem.cost = costDetail?.cost;
          }

          if (!groupedResult[rateCategoryId]) {
            groupedResult[rateCategoryId] = [];
          }
          groupedResult[rateCategoryId]?.push(resultItem);
        });

        const EmployeeSalaryPackage = groupedResult[1];
        const GovernmentFee = groupedResult[2];
        const SoundLineFee = groupedResult[3];

        console.log(groupedResult, "grouped results");

        setAllRows([
          {
            id: BASIC?.id,
            job_position_id: BASIC?.job_position_id,
            visa_profession_id: BASIC?.visa_profession_id,
            profession_level_id: BASIC?.profession_level_id,
            gender: BASIC?.gender,
            nationality_id: BASIC?.nationality_id,
            quantity: BASIC?.quantity,
            sections: [
              {
                rate_category_id: 1,
                columns: EmployeeSalaryPackage,
              },
              {
                rate_category_id: 2,
                columns: GovernmentFee,
              },
              {
                rate_category_id: 3,
                columns: SoundLineFee,
              },
            ],
          },
        ]);
        setCostSheetDefault(response);
      })
      .catch((err) => {
        dispatch(
          setAppError({
            msg: err?.message,
          })
        );
      })
      .finally(() => {
        setCostSheetDataLoading(false);
      });
  }, []);

  const handleUpdateColumn = (
    rowId,
    rate_category_id,
    columnId,
    updatedKey,
    updatedValue,
    columnName
  ) => {
    setAllowEdit(true);

    const updatedRows = allRows?.map((row) => {
      let currentValueOfHRA = 0;
      let currentValueOfBasic = 0;
      if (updatedKey == "cost") {
        if (row?.id == rowId) {
          const updatedSections = row?.sections?.map((section) => {
            if (section.rate_category_id == 1) {
              currentValueOfHRA = Number(
                section.columns.find(
                  (column) => column?.rate_category_item_name == "HRA"
                )?.cost
              );
            }
            if (section.rate_category_id == 1) {
              currentValueOfBasic = Number(
                section.columns.find(
                  (column) => column?.rate_category_item_name == "BASIC"
                )?.cost
              );
            }
            if (section?.rate_category_id == rate_category_id) {
              const updatedColumns = section?.columns?.map((column) => {
                if (column?.id == columnId) {
                  return { ...column, [updatedKey]: updatedValue };
                }
                return column;
              });
              return { ...section, columns: updatedColumns };
            }
            if (columnName == "BASIC" && section.rate_category_id == 2) {
              const updatedCostByEquation = section.columns.map((column) => {
                if (column?.rate_category_item_name == "END OF SERVICE") {
                  return {
                    ...column,
                    cost: Number(
                      (Number(updatedValue) / 30) * (15 / 12)
                    ).toFixed(2),
                  };
                } else if (
                  column?.rate_category_item_name == "VACATION SALARY"
                ) {
                  return {
                    ...column,
                    cost: Number(
                      (Number(updatedValue) / 30) * (21 / 12)
                    ).toFixed(2),
                  };
                }
                return column;
              });
              return { ...section, columns: updatedCostByEquation };
            }
            if (columnName == "BASIC" && section.rate_category_id == 3) {
              const updatedGosi = section.columns.map((column) => {
                if (column.rate_category_item_name == "GOSI") {
                  return {
                    ...column,
                    cost: (
                      ((Number(updatedValue) + Number(currentValueOfHRA)) * 2) /
                      100
                    )?.toFixed(2),
                  };
                }
                return column;
              });
              return { ...section, columns: updatedGosi };
            }
            if (columnName == "HRA" && section.rate_category_id == 3) {
              const updatedGosi = section.columns.map((column) => {
                if (column.rate_category_item_name == "GOSI") {
                  return {
                    ...column,
                    cost: (
                      ((Number(updatedValue) + Number(currentValueOfBasic)) *
                        2) /
                      100
                    )?.toFixed(2),
                  };
                }
                return column;
              });
              return { ...section, columns: updatedGosi };
            }
            return section;
          });
          return { ...row, sections: updatedSections };
        }
        return row;
      } else {
        const updatedSections = row?.sections?.map((section) => {
          if (section?.rate_category_id == rate_category_id) {
            const updatedColumns = section?.columns?.map((column) => {
              if (column?.id == columnId) {
                return { ...column, [updatedKey]: updatedValue };
              }
              return column;
            });
            return { ...section, columns: updatedColumns };
          }
          return section;
        });
        return { ...row, sections: updatedSections };
      }
    });

    setAllRows(updatedRows);
  };

  const handleUpdateRowProperties = (rowId, updatingKey, updatingValue) => {
    setAllowEdit(true);

    const updatedRows = allRows?.map((row) => {
      if (row?.id == rowId) {
        if (updatingKey == "profession_level_id") {
          const updatedSections = row?.sections?.map((section) => {
            if (section?.rate_category_id == 3) {
              const updatedColumns = section?.columns?.map((column) => {
                if (column?.rate_category_item_name == "NITAKAT") {
                  return {
                    ...column,
                    cost: costSheetDefault?.profession_level?.find(
                      (profession) => profession?.id == updatingValue
                    )?.nitakat,
                  };
                }
                if (column?.rate_category_item_name == "ADMIN FEE") {
                  return {
                    ...column,
                    cost: costSheetDefault?.profession_level?.find(
                      (profession) => profession?.id == updatingValue
                    )?.admin_fee,
                  };
                }
                if (
                  column?.rate_category_item_name == "SOUNDLINE SERVICE FEE"
                ) {
                  return {
                    ...column,
                    cost: costSheetDefault?.profession_level?.find(
                      (profession) => profession?.id == updatingValue
                    )?.soundline_fee,
                  };
                }
                return column;
              });
              return { ...section, columns: updatedColumns };
            }
            return section;
          });
          return {
            ...row,
            sections: updatedSections,
            [updatingKey]: updatingValue,
          };
        }
        return { ...row, [updatingKey]: updatingValue };
      }
      return row;
    });
    setAllRows(updatedRows);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    const inputData = [...allRows];
    const body = {
      job_position_id: inputData[0]?.job_position_id,
      visa_profession_id: inputData[0]?.visa_profession_id,
      profession_level_id: inputData[0]?.profession_level_id,
      gender: inputData[0]?.gender,
      nationality_id: inputData[0]?.nationality_id,
      quantity: inputData[0]?.quantity,
      cost_sheet: [],
    };

    // Iterate through sections
    inputData[0]?.sections?.forEach((section) => {
      section?.columns?.forEach((column) => {
        // Push cost and heading_id to the result
        body?.cost_sheet?.push({
          heading_id: column?.id,
          cost: column?.cost,
        });
      });
    });

    axios
      .put(`/dashboard/quotation-cost-sheet-module/${costSheetId}`, body, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        dispatch(
          setAppError({
            msg: res?.data?.message || "Updated Successfully.d",
            color: "success",
          })
        );
        updateCostSheetForm((p) => ({
          open: false,
          method: "View",
        }));
        navigate(`/dashboard/quotation/${quotationId}`, {
          state: { method: "View", quotationId: quotationId },
        });
      })
      .catch((err) => {
        dispatch(
          setAppError({
            msg: err?.message,
          })
        );
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  return (
    <div>
      <h2 className="text-2xl text-center font-bold mb-10">COST SHEET EDIT</h2>
      {!costSheetDataLoading ? (
        <>
          {/* <div className="text-sm mx-auto max-w-sm">
            <div className="text-left">
              <p>
                <b> Quotation No.</b>: {quotationDetails?.number}
              </p>
              <p>
                <b>Quotation Name</b> : {quotationDetails?.name}
              </p>
              <p>
                <b>Quotation Type</b> : {quotationDetails?.type}
              </p>
              <p>
                <b>Client Name</b> : {quotationDetails?.clientName}
              </p>
              <p
                className={`mb-1 ${
                  quotationDetails?.clientSpecific?.length < 20
                    ? "flex"
                    : "block"
                }`}
              >
                <b>Client Specific </b> :{quotationDetails?.clientSpecific}
              </p>
            </div>
          </div> */}

          <div className="flex flex-col w-full gap-1 my-12 overflow-x-scroll pl-16 pt-8 pb-5">
            {quotationDetails?.type?.name === "Cost Plus" ? (
              <>
                <CPCostSheetEdit
                  apiData={apiData}
                  tableHeading={tableHeading}
                  style={style}
                  costSheetDefault={costSheetDefault}
                  submitLoading={submitLoading}
                  allowEdit={allowEdit}
                  updateCostSheetForm={updateCostSheetForm}
                  quotationId={quotationId}
                  costSheetId={costSheetId}
                />
              </>
            ) : (
              <form onSubmit={handleSubmit}>
                {allRows?.map((row, index) => (
                  <div key={row?.id} className="flex gap-1 mt-1 ">
                    {row?.sections?.map((section, sectionIndex) => (
                      <div
                        className="flex flex-col relative"
                        key={section?.rate_category_id}
                      >
                        {index == 0 && (
                          <>
                            <div
                              className={`w-full text-white py-2  ${tableHeading[sectionIndex]?.bgPrimary}`}
                            >
                              <h2 className="text-center">
                                {tableHeading[sectionIndex]?.title}
                              </h2>
                            </div>
                            <div className={`flex w-full gap-1 `}>
                              {section?.rate_category_id == 1 && (
                                <>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style?.colWidth} ${style?.itemHeight}`}
                                  >
                                    SL. NO.
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style?.colWidth} ${style?.itemHeight}`}
                                  >
                                    ACTUAL PROFESSION
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style.colWidth} ${style.itemHeight}`}
                                  >
                                    VISA PROFESSION
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style.colWidth} ${style.itemHeight}`}
                                  >
                                    PROFESSION LEVEL
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style.colWidth} ${style.itemHeight}`}
                                  >
                                    GENDER
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style?.colWidth} ${style?.itemHeight}`}
                                  >
                                    NATIONALITY
                                  </h3>

                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style.colWidth} ${style.itemHeight}`}
                                  >
                                    QUANTITY
                                  </h3>
                                </>
                              )}
                              {section?.columns?.map((column) => (
                                <div
                                  key={column?.id}
                                  className={`${tableHeading[sectionIndex]?.bgSecondary}  ${style?.colWidth} ${style?.itemHeight} flex justify-center items-center relative`}
                                >
                                  <h3 className="text-center text-sm">
                                    {column?.title}
                                  </h3>
                                </div>
                              ))}
                              {section.rate_category_id == 1 && (
                                <h3
                                  className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style.colWidth} ${style.itemHeight}`}
                                >
                                  Total Emp. Salary Package
                                </h3>
                              )}
                              {section.rate_category_id == 2 && (
                                <h3
                                  className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style.colWidth} ${style.itemHeight}`}
                                >
                                  Total Gov. Fees
                                </h3>
                              )}
                              {section.rate_category_id == 3 && (
                                <h3
                                  className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex]?.bgSecondary} ${style.colWidth} ${style.itemHeight}`}
                                >
                                  Total Soundline Fees
                                </h3>
                              )}
                            </div>
                          </>
                        )}
                        <div className="flex w-full gap-1 relative">
                          {section?.rate_category_id == 1 && (
                            <>
                              <p
                                className={` bg-slate-200 flex items-center justify-center  ${style?.colWidth} ${style?.colHeight}`}
                              >
                                {index + 1}
                              </p>

                              {/* ACTUAL PROFESSION / JOB POSITION  */}
                              <select
                                value={row?.job_position_id}
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                                required
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row?.id,
                                    "job_position_id",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                {costSheetDefault?.job_possition?.map(
                                  (optionData) => (
                                    <option
                                      value={optionData?.id}
                                      key={optionData?.id}
                                    >
                                      {optionData?.name}
                                    </option>
                                  )
                                )}
                              </select>

                              {/* VISA PROFESSION */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                                required
                                value={row?.visa_profession_id}
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row?.id,
                                    "visa_profession_id",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                {costSheetDefault?.visa_profession?.map(
                                  (optionData) => (
                                    <option
                                      value={optionData?.id}
                                      key={optionData?.id}
                                    >
                                      {optionData?.name}
                                    </option>
                                  )
                                )}
                              </select>

                              {/* PROFESSIONAL LEVEL */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                                required
                                value={row?.profession_level_id}
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row?.id,
                                    "profession_level_id",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                {costSheetDefault?.profession_level?.map(
                                  (optionData) => (
                                    <option
                                      value={optionData?.id}
                                      key={optionData?.id}
                                    >
                                      {optionData?.name}
                                    </option>
                                  )
                                )}
                              </select>

                              {/* GENDER */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                                required
                                value={row?.gender}
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row?.id,
                                    "gender",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                <option value="FEMALE">FEMALE</option>
                                <option value="MALE">MALE</option>
                              </select>

                              {/* NATIONALITY */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                                required
                                value={row?.nationality_id}
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row?.id,
                                    "nationality_id",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                {costSheetDefault?.nationality?.map(
                                  (optionData) => (
                                    <option
                                      value={optionData?.id}
                                      key={optionData?.id}
                                    >
                                      {optionData?.name}
                                    </option>
                                  )
                                )}
                              </select>

                              {/* QUANTITY */}
                              <input
                                type="text"
                                value={row?.quantity}
                                className={`bg-slate-200 input input-sm rounded-none focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                                required
                                placeholder="ENTER QUANTITY"
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row?.id,
                                    "quantity",
                                    e.target.value?.toUpperCase()
                                  )
                                }
                              />
                            </>
                          )}
                          {section?.columns?.map((column) => (
                            <input
                              key={`${row?.id}-${column?.id}`}
                              type="number"
                              min={0}
                              className={`input input-sm rounded-none bg-slate-200 focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                              placeholder="Enter Cost"
                              value={column?.cost}
                              step={"0.0001"}
                              required
                              onChange={(e) =>
                                handleUpdateColumn(
                                  row?.id,
                                  column?.rate_category_id,
                                  column?.id,
                                  "cost",
                                  parseFloat(e.target.value),
                                  column?.rate_category_item_name
                                )
                              }
                            />
                          ))}
                          <input
                            type="text"
                            className={`bg-slate-200 input input-sm rounded-none focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                            placeholder="Total"
                            disabled={true}
                            value={Number(
                              section?.columns?.reduce(
                                (accumulator, currentObject) =>
                                  accumulator +
                                  Number(currentObject?.cost || 0),
                                0
                              )
                            ).toFixed(2)}
                          />
                        </div>
                      </div>
                    ))}
                    {quotationDetails?.type?.name == "Hourly" && (
                      <div className="flex flex-col relative">
                        {index === 0 && (
                          <>
                            <div
                              className={`w-full text-white bg-zinc-800 py-2`}
                            >
                              <h2 className="text-center">Total</h2>
                            </div>
                            <div className={`flex w-full gap-1 `}>
                              <h3
                                className={`flex justify-center items-center text-sm bg-zinc-300 ${style.colWidth} ${style.itemHeight}`}
                              >
                                Per Hour Rate
                              </h3>
                            </div>
                          </>
                        )}
                        <div className="flex w-full gap-1 relative">
                          <input
                            type="text"
                            className={`input input-sm rounded-none bg-slate-200 focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                            placeholder="Total"
                            disabled={true}
                            value={(
                              Number(
                                row?.sections?.reduce(
                                  (accumulator, currentObject) => {
                                    const sectionSum =
                                      currentObject?.columns?.reduce(
                                        (colAccumulator, column) =>
                                          colAccumulator +
                                          Number(column?.cost || 0),
                                        0
                                      );
                                    return accumulator + Number(sectionSum);
                                  },
                                  0
                                )
                              ) /
                              26 /
                              Number(routerState?.hourType)
                            ).toFixed(2)}
                          />
                        </div>
                      </div>
                    )}
                    <div className="flex flex-col relative">
                      {index === 0 && (
                        <>
                          <div className={`w-full text-white bg-zinc-800 py-2`}>
                            <h2 className="text-center">Total</h2>
                          </div>
                          <div className={`flex w-full gap-1 `}>
                            <h3
                              className={`flex justify-center items-center text-sm bg-zinc-300 ${style.colWidth} ${style.itemHeight}`}
                            >
                              Total Monthly Per Head Cost
                            </h3>
                          </div>
                        </>
                      )}
                      <div className="flex w-full gap-1 relative">
                        <input
                          type="text"
                          className={`input input-sm rounded-none bg-slate-200 focus:outline-none ${style?.colWidth} ${style?.colHeight}`}
                          placeholder="Total"
                          disabled={true}
                          value={Number(
                            row?.sections?.reduce(
                              (accumulator, currentObject) => {
                                const sectionSum =
                                  currentObject?.columns?.reduce(
                                    (colAccumulator, column) =>
                                      colAccumulator +
                                      Number(column?.cost || 0),
                                    0
                                  );
                                return accumulator + Number(sectionSum);
                              },
                              0
                            )
                          ).toFixed(2)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
                <div className="absolute left-1/2 flex  w-full max-w-xs mt-16 gap-4">
                  <button
                    className="ring-1 ring-black dark:ring-red uppercase w-full text-xs dark:text-white rounded-md py-2 flex justify-center items-center gap-2"
                    type="submit"
                    disabled={submitLoading}
                    onClick={() => {
                      updateCostSheetForm((p) => ({
                        open: false,
                        method: "View",
                      }));
                      navigate(`/dashboard/quotation/${quotationId}`, {
                        state: { method: "View", quotationId: quotationId },
                      });
                    }}
                  >
                    CANCEL
                  </button>

                  <button
                    className="bg-red rounded-md  text-white  p-2 px-10 cursor-pointer text-sm
                        disabled:bg-rose-400 
                    "
                    type="submit"
                    disabled={submitLoading || !allowEdit}
                    title={`${!allowEdit ? "No changes made yet" : ""}`}
                  >
                    {submitLoading ? (
                      <LoadingWithLable className={"!mt-0  text-white "} />
                    ) : (
                      `SUBMIT`
                    )}
                  </button>
                </div>
              </form>
            )}
          </div>
        </>
      ) : (
        <LoadingWithLable />
      )}
    </div>
  );
}
